export default {
  'form.required': 'Требуемые',
  'input.good': 'Хорошо',
  //<!----- header ------!>
  'header.book': 'Рейс',
  'header.upgradetobusiness': 'Изменить на партнера',
  'header.checkin': 'Бронь',
  'header.manage': 'Приборная',
  'header.login': 'Входить',
  'header.signup': 'Зарегистрироваться',
  'header.dashboard': 'Приборная',
  'header.logout': 'Выйти',
  'header.ticket': 'Билеты',
  'header.Booking': 'Бронирование',
  'header.aboutus': 'О нас',
  'header.smarttripsi': 'Smart Tripsi',
  'header.smarttripord': 'Smart Tripord',
  'header.contactus': 'Связаться с нами',
  //<!----- footer ------!>
  'footer.supports': 'Наши поддержки',
  'footer.onlinechat': 'Онлайн чат',
  'footer.customer': 'Обслуживание клиентов',
  'footer.reserve': 'Поддержка бронирования',
  'footer.fax': 'Факс',
  'footer.email': 'Эл. Адрес: Support.Tripsi.com',
  'footer.services': 'Наши услуги',
  'footer.flight': 'Рейс',
  'footer.hotel': 'Отель',
  'footer.tour': 'Тур',
  'footer.who': 'Кто мы',
  'footer.aboutus': 'О Нас',
  'footer.contactus': 'Связаться с нами',
  'footer.members': 'Наши члены',
  'footer.board': 'Совет директоров',
  'footer.history': 'История',
  'footer.privacypolicy': 'Политика конфиденциальности',
  'footer.privacy': 'Конфиденциальность',
  'footer.claim': 'Заявления',
  'footer.rules': 'Правила',
  'footer.address': 'Адрес',
  'footer.subscribe': 'Подписка новости',
  'footer.copyright': 'Copyright © 2018 Tripsi Inc, Все права защищены.',
  'footer.tourismMagazine': 'Tourism Magazine',
  'footer.customerClub': 'Клуб клиентов',
  'footer.ticketGuide': 'Ticket Guide',
  'footer.english': 'Английский',
  'footer.persian': 'Фарси',
  //<!----- aboutus ------!>
  'aboutus.tripsi': 'о Tripsi',
  'aboutus.tripord': 'о Tripord',
  'aboutus.tripsiAboutus': `Компания Tolo Air Travel and Pilgrimage Service начала свою деятельность в большой индустрии туризма в 1373 году. Большая команда Tolo, насчитывающая более 25 сотрудников, включая отдел продаж в Тегеране и технический отдел в Ширазе, всегда стремится предоставлять лучшие услуги и программное обеспечение высочайшего качества. чтобы удовлетворить текущих поставщиков. Эта компания начала свою деятельность в сфере туристических услуг онлайн под названием Tripsi в 1401 году. Политика системы Tripsi основана на удовлетворении клиентов и заинтересованных сторон и предоставлении клиентам превосходных и отличительных услуг.`,
  'aboutus.tripordAboutus': `В Tripord мы больше, чем просто онлайн-платформа для путешествий; мы — ваш надежный спутник в превращении мечты о путешествии в незабываемую реальность. Основанная в 2021 году, Tripord родилась из более чем двадцатилетнего опыта в туристической индустрии с целью создания бесшовной, инновационной и всеобъемлющей экосистемы путешествий.`,
  'aboutus.service1_tripsi':
    'Представитель всех внутренних и международных авиакомпаний',
  'aboutus.service2_tripsi':
    'Агентство по продаже междугородних билетов за границу',
  'aboutus.service3_tripsi':
    'Агентство по продаже зарубежных билетов на системной и чартерной основе',
  'aboutus.service4_tripsi':
    'Агентство по продаже внутренних билетов на системной и чартерной основе',
  'aboutus.service5_tripsi':
    'Международное агентство по продаже билетов на поезд',
  'aboutus.service6_tripsi':
    'Оформление стартовых билетов из-за границы (СОТО)',
  'aboutus.service7_tripsi':
    'Организация и подготовка отечественных и зарубежных туров',
  'aboutus.service8_tripsi': 'Проведение профильных семинаров и конференций',
  'aboutus.service9_tripsi':
    'Предоставление услуг по визовым вопросам и посольствам, в том числе (время посольства и получение паспорта)',
  'aboutus.service10_tripsi': 'Предоставление услуг трансфера в аэропорт (CIP)',
  'aboutus.service11_tripsi': 'Бронирование отелей по всему Ирану и миру',
  'aboutus.service12_tripsi':
    'Организация паломнических караванов, паломничества и умры под наблюдением хаджа и паломничества',
  'aboutus.service1_tripord':
    'О Tripord: Переосмысливая путешествия шаг за шагом. В Tripord мы верим, что путешествия должны быть легкими, персонализированными и незабываемыми. Наша миссия — изменить ваш способ познания мира, предлагая умные решения, тщательно отобранные впечатления и круглосуточную поддержку — всё в одной платформе. От роскошного отдыха и экотуризма до скрытых жемчужин и загородных ферм — мы открываем для вас невероятные приключения по выгодным ценам.',
  'aboutus.service2_tripord': 'Почему стоит путешествовать с нами?',
  'aboutus.service3_tripord':
    '• Все-в-одном: Авиабилеты, проживание, экскурсии и многое другое, подобранное под ваши предпочтения.',
  'aboutus.service4_tripord':
    '• Инновации и надежность: Передовые технологии, безопасное бронирование и прозрачные цены.',
  'aboutus.service5_tripord':
    '• Вознаграждения, которые важны: Зарабатывайте и используйте бонусы через нашу программу лояльности Tripord Loyalty Club.',
  'aboutus.service6_tripord':
    '• Поддержка 24/7: Помощь в любое время, в любом месте, 365 дней в году.',
  'aboutus.service7_tripord':
    '• Устойчивый туризм: Мы поддерживаем экологически чистый туризм и заботу о местных сообществах.',
  'aboutus.service8_tripord':
    'Обладая опытом и страстью к открытиям, Tripord — это не просто сервис для путешествий, а ваш надежный партнер в создании вдохновляющих маршрутов.',
  'aboutus.service9_tripord': 'Открывайте больше. Беспокойтесь меньше.',
  'aboutus.address':
    'Тегеран, улица Валиаср, над Зафарание, рядом с банком Рефах, № 3061, этаж 2, помещение 6',
  'aboutus.company': 'Компания Доньяро Парса Киш',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'Address : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  //<!----- aboutus ------!>
  'dashboard.flightDescriptionTripsi':
    'Покупайте внутренние и международные рейсы из Доньяро по лучшей цене',
  'dashboard.flightDescriptionTripord':
    'Покупайте внутренние и международные рейсы из Доньяро по лучшей цене',
  'dashboard.overview': 'Обзор',
  'dashboard.book': 'Бронь',
  'dashboard.search': 'Поиск',
  'dashboard.reserve': 'ВЫПУЩЕН',
  'dashboard.staffs': 'Персонал',
  'dashboard.random': 'Случайный',
  'dashboard.stats': 'Статистика',
  'dashboard.overalview': 'ОБЩИЙ ВИД',
  'dashboard.lastactivities': 'ПОСЛЕДНИЕ ДЕЙСТВИЯ',
  'dashboard.opportunities': 'возможности',
  'dashboard.tickets': 'покупной',
  'dashboard.open': 'НОВОСТИ',
  'dashboard.rating': 'уровень',
  'dashboard.openrequest': 'ОТКРЫТЫЕ ЗАПРОСЫ',
  'dashboard.derik': 'Дерик',
  'dashboard.showmore': 'Больше...',
  'dashboard.onlinetickets': 'Онлайн билет',
  'dashboard.favoritetrips': 'Мои любимые поездки',
  'dumb.amount_of_new_users': 'Количество новых пользователей: {amountOfUsers}',
  'dumb.display_width': '<strong>Width: {width}</strong>',
  'dumb.display_height': '<strong>Height: {height}</strong>',
  //<!----- confirmation ------!>
  'confirmation.reject': 'Нет',
  'confirmation.confirm': 'Да',
  'confirmation.confirmTitle': 'Подтверждение',
};
